import type { operations } from '@/types/schemas/api.JS-6223';
import { GET, setParams } from '../../_http';
type controller = operations['BrokerRetrieveDischargedPropertiesController_get'];

export type BrokerRetrieveDischargedPropertiesQuery = controller['parameters']['query'];
export type BrokerRetrieveDischargedPropertiesResponse = controller['responses']['200']['content']['application/json'];

export const retrieveDischargedProperties = GET(
  '/brokers/discharge-requests/retrieve-discharged-properties',
  setParams<BrokerRetrieveDischargedPropertiesQuery>,
)<BrokerRetrieveDischargedPropertiesResponse>;
